import React, { useRef, useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useMonitoreo } from './MonitoreoContext';
import LlamadasActivasCounter from './LlamadasActivasCounter';

const MAX_MINUTES = 60;

export default function GaugeResponseTime() {
    const { promedioResumen } = useMonitoreo();
    const wrapperRef = useRef(null);
    const [chartSize, setChartSize] = useState(260);

    useEffect(() => {
        const el = wrapperRef.current;
        if (!el) return;
        const observer = new ResizeObserver(([entry]) => {
            const h = entry.contentRect.height;
            if (h > 40) setChartSize(h);
        });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    const avgMinutes = promedioResumen.tiempoRespuesta ?? 0;
    const percentage = Math.min(100, Math.round((avgMinutes / MAX_MINUTES) * 100));

    const formatAvg = (mins) => {
        const m = Math.floor(mins);
        const s = Math.round((mins - m) * 60);
        return m > 0 ? `${m}m ${s}s` : `${s}s`;
    };

    // Verde < 30 min, naranja 30-45 min, rojo > 45 min
    const gaugeColor = avgMinutes < 30 ? '#2ccb9e' : avgMinutes < 45 ? '#ffc800' : '#ff3b30';

    const options = {
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 135,
                offsetY: -18,
                track: { background: '#e7e7e7', strokeWidth: '97%', margin: 4 },
                hollow: { size: '52%' },
                dataLabels: {
                    name: { show: false },
                    value: { show: false },
                },
            },
        },
        chart: {
            type: 'radialBar',
            sparkline: { enabled: true },
            parentHeightOffset: 0,
            offsetY: -10,
        },
        fill: { colors: [gaugeColor] },
        labels: ['Respuesta'],
    };

    return (
        <div className="andon-gauge">
            <p className="andon-gauge-title">T. respuesta promedio</p>
            <div className="andon-gauge-chart" ref={wrapperRef}>
                <ReactApexChart
                    type="radialBar"
                    series={[percentage]}
                    options={options}
                    height={chartSize}
                    width="100%"
                />
                <p className={`andon-gauge-value${avgMinutes === 0 ? ' andon-gauge-value--empty' : ''}`}>
                    {avgMinutes === 0 ? '—' : formatAvg(avgMinutes)}
                </p>
            </div>
            <LlamadasActivasCounter />
        </div>
    );
}
